module.exports = __webpack_public_path__ + "static/media/reentryBurn.8bc1bd8f.png";